var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:[
        _vm.hasBgColor && 'has-bg-color',
        _vm.invertColor && 'invert-color'
    ]},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section-inner",class:[
                _vm.topDivider && 'has-top-divider',
                _vm.bottomDivider && 'has-bottom-divider'
            ]},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }